var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-overlay has-background-dark-transparent max-h-100vh has-text-white z-index-100 is-flex is-absolute-center"},[_c('font-awesome-icon',{attrs:{"spin":"","size":"3x","icon":['fal', 'spinner-third']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }